"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarSignalHelper = void 0;
class NavBarSignalHelper {
    static initializeSignals() {
        // Get or create signals using simplified getSignal
        this.modelSignal = this.signalService.getSignal('selected_model', { initialValue: null });
        this.conversationSignal = this.signalService.getSignal('selected_conversation', { initialValue: null });
        this.navBarSignal = this.signalService.getSignal('nav_bar', { initialValue: null });
        this.navBarSignal.value$.subscribe(config => {
            if (!config) {
                this.showChatControls = false;
            }
            else {
                this.showChatControls = config.showChatControls;
            }
        });
        // Subscribe to signal changes to keep nav-bar in sync with external updates
        this.subscribeToSignalChanges();
    }
    static subscribeToSignalChanges() {
        this.modelSignal.value$.subscribe(async (selectedModel) => {
            if (selectedModel) {
                const aiProvider = selectedModel.aiProvider || 'inthub';
                const provider = selectedModel.provider || { name: "IntHub Avatar", value: "inthub" };
                const model = selectedModel.model;
                this.storageService.set('ai.selectedAIProvider', aiProvider);
                this.storageService.set('ai.selectedProvider', JSON.stringify(provider));
                this.storageService.set('ai.selectedModel', JSON.stringify(model));
                if (selectedModel.avatar) {
                    this.storageService.set('ai.selectedAvatar', String(selectedModel.avatar));
                }
                else {
                    console.log('Clearing selected avatar from storage (Nav-BarSignalHelper)');
                    this.storageService.clear('ai.selectedAvatar');
                }
                // Update local observables to keep nav-bar UI in sync
                this.selectedAIProvider = selectedModel.aiProvider;
                this.selectedModel = selectedModel.model;
                this.selectedAvatarId = selectedModel.avatar;
                // Load avatar data if avatar is selected
                if (selectedModel.avatar) {
                    const avatar = await NavBarSignalHelper.loadAvatarById.call(this, selectedModel.avatar);
                    if (avatar) {
                        this.selectedAvatar = avatar;
                    }
                }
                else {
                    this.selectedAvatar = undefined;
                }
            }
            else {
                // Don't clear local state on null signals - use separate clear signal instead
            }
        });
        this.conversationSignal.value$.subscribe(conversation => {
            if (conversation && conversation.conversation !== this.selectedConversation) {
                this.selectedConversation = conversation.conversation;
            }
        });
    }
    static getCurrentSelectedModel() {
        if (!this.selectedAIProvider || !this.selectedModel) {
            return null;
        }
        return {
            aiProvider: this.selectedAIProvider,
            model: this.selectedModel,
            provider: { name: this.selectedModel.label || 'Unknown', value: this.selectedModel.value },
            avatar: this.selectedAvatarId
        };
    }
    static onSelect(selected) {
        if (selected) {
            // Ensure we don't save undefined values that would break JSON parsing
            const aiProvider = selected.aiProvider || 'inthub';
            const provider = selected.provider || { name: "IntHub Avatar", value: "inthub" };
            const model = selected.model;
            // Save to localStorage immediately when user makes selection
            this.storageService.set('ai.selectedAIProvider', aiProvider);
            this.storageService.set('ai.selectedProvider', JSON.stringify(provider));
            this.storageService.set('ai.selectedModel', JSON.stringify(model));
            if (selected.avatar) {
                this.storageService.set('ai.selectedAvatar', String(selected.avatar));
            }
            else {
                console.log('Clearing selected avatar from storage (Nav-BarSignalHelper) onSelect');
                this.storageService.clear('ai.selectedAvatar');
            }
            // Update local observables for nav-bar display
            this.selectedAIProvider = selected.aiProvider;
            this.selectedModel = selected.model;
            this.selectedAvatarId = selected.avatar;
            // Load avatar data if avatar is selected
            if (selected.avatar) {
                NavBarSignalHelper.loadAvatarById.call(this, selected.avatar).then(avatar => {
                    this.selectedAvatar = avatar;
                });
            }
            else {
                this.selectedAvatar = undefined;
            }
        }
        else {
            // Clear selection - use separate clear signal to prevent confusion
            const clearSignal = this.signalService.getSignal('clear_model_selection', { initialValue: false });
            clearSignal.setValue(true);
            return; // Don't send null to main signal
        }
        // Send the signal to notify other components (like chat)
        this.modelSignal.setValue(selected);
    }
    static async loadAvatarById(avatarId) {
        try {
            const response = await this.apiService.back.get('avatar.list', {
                queryParams: { widget: '1' }
            });
            return response.data.find(a => a.id === Number(avatarId));
        }
        catch (error) {
            return undefined;
        }
    }
    static onConversationSelected(event) {
        const { conversation, messages } = event.detail;
        // Update local observable for nav-bar display
        this.selectedConversation = conversation;
        // Send the signal to notify other components (like chat)
        this.conversationSignal.setValue({ conversation: conversation, frontMessages: messages, isNew: false });
    }
    static cleanupSignals() {
        // Cleanup signal subscriptions
        this.signalSubscriptions.forEach(subscription => subscription.unsubscribe());
        this.signalSubscriptions = [];
    }
}
exports.NavBarSignalHelper = NavBarSignalHelper;
